var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import UVCard from "./UVCard";
var UVDialog = function (_a) {
    var manifest = _a.manifest, handleClose = _a.handleClose, viewerPath = _a.viewerPath;
    return (_jsxs(Dialog, __assign({ fullScreen: true, open: manifest !== null, onClose: handleClose }, { children: [_jsx(AppBar, __assign({ position: "fixed" }, { children: _jsxs(Toolbar, __assign({ sx: { backgroundColor: "dimgray" } }, { children: [_jsx(IconButton, __assign({ edge: "start", color: "inherit", onClick: handleClose, "aria-label": "close" }, { children: _jsx(CloseIcon, { fontSize: "small" }, void 0) }), void 0), _jsx(Typography, __assign({ variant: "h5", component: "h1", p: 2 }, { children: "Item View" }), void 0)] }), void 0) }), void 0), _jsx(Toolbar, {}, void 0), _jsx(UVCard, { manifest: manifest, viewerPath: viewerPath }, void 0)] }), void 0));
};
export default UVDialog;
